import React, { createContext, useState, useCallback } from 'react';

export const OrderUndoContext = createContext();

export const OrderUndoProvider = ({ children }) => {
  // Stack of order changes: [{orderId, orderType, oldPrice, newPrice, updatePayload}]
  const [undoStack, setUndoStack] = useState([]);

  // Push a new order change to the undo stack
  const pushOrderChange = useCallback((orderId, orderType, oldPrice, newPrice, updatePayload, accountId = null) => {
    const change = {
      orderId,
      orderType, // 'limit', 'stopLoss', 'takeProfit'
      oldPrice,
      newPrice,
      updatePayload, // The payload that was used to update the order
      accountId,
      timestamp: Date.now()
    };

    setUndoStack(prev => [...prev, change]);
  }, []);

  // Pop the most recent order change from the stack
  const popOrderChange = useCallback(() => {
    if (undoStack.length === 0) return null;

    const lastChange = undoStack[undoStack.length - 1];
    setUndoStack(prev => prev.slice(0, -1));
    
    return lastChange;
  }, [undoStack]);

  // Check if there are any changes to undo
  const canUndo = undoStack.length > 0;

  // Clear the undo stack (e.g., on page reload or manual clear)
  const clearUndoStack = useCallback(() => {
    setUndoStack([]);
  }, []);

  return (
    <OrderUndoContext.Provider
      value={{
        pushOrderChange,
        popOrderChange,
        canUndo,
        clearUndoStack,
        undoStack
      }}
    >
      {children}
    </OrderUndoContext.Provider>
  );
};



